import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorToast, SuccessToast } from '../../components';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { DASHBOARD } from '../../routes/routes';
import { decodeJwt } from '../../helpers/helperFunctions';
import { UserInfoType } from '../../types/loginTypes';
import { setTokensToLS, setUserToLS } from '../../helpers/localstorage-helper';
import { signInComplete } from '../../slices/auth-slice';

interface SendSecurityCodeType {
  signInToken: string;
  setIsCodeSent: Dispatch<SetStateAction<boolean>>;
}

export const sendSecurityCode = createAsyncThunk(
  'auth/sendSecurityCode',
  async (
    {
      result,
      code,
      email,
      history
    }: {
      result: any;
      code: string;
      email: any;
      history: any;
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const {
        lot_number: lotNumber,
        captcha_output: captchaOutput,
        pass_token: passToken,
        gen_time: genTime
      } = result;

      const response = await axios.post(
        `/authorization/email-otp/signin/verify`,
        {
          code,
          email,
          lotNumber,
          captchaOutput,
          passToken,
          genTime
        }
      );

      dispatch(
        signInComplete({
          signInToken: response.data.data.signInToken,
          emailCode: null,
          twoFAcode: null,
          is2FARequired: false,
          history
        })
      );
    } catch (error: any) {
      console.log(error);
      ErrorToast(error?.response?.data.error);
    }
  }
);
